<template>
  <b-modal
    size="lg"
    title="Pobierz permalink do innej mapy"
    v-model="mapPermalinksVisible"
    @hide="cancel"
  >
    <template #modal-header="{ close }">
      <h5 class="v-step-0">Pobierz permalink do innej mapy</h5>
      <!-- <button class="cursor-pointer v-step-12" v-on:click="startTour()">
                      <span class="oi oi-question-mark" title="Asystent" aria-hidden="true"></span>
                      <span class="sr-only">Asystenet</span>
                    </button> -->

      <b-row class="pr-3 gap-3"
        ><b-button
          v-if="isMobileDevice"
          class="question-button"
          :variant="contextAssistantActive ? 'warning' : 'secondary'"
          @click="toggleAssistant"
        >
          <span
            :variant="'warning'"
            class="oi oi-question-mark"
            title="Asystent"
            aria-hidden="true"
          ></span>
          <span class="sr-only">Asystenet</span>
        </b-button>
        <button @click="cancel" class="close">
          <span aria-hidden="true">&times;</span>
        </button></b-row
      >

      <!-- <i class="bi bi-question-circle"></i> -->
    </template>
    <b-alert :show="linkCopiedModal" variant="success">
      <span>Poprawnie skopiowano link.</span>
    </b-alert>
    <b-row
      ><b-col class="d-flex justify-content-center"
        ><H5>Mapy google</H5></b-col
      ></b-row
    >
    <div class="input-group mb-3 cursor-pointer">
      <input
        type="text"
        class="form-control"
        placeholder="Wygenerowany permalink"
        aria-label="Wygenerowany permalink"
        v-model="permalinks.googleMaps"
        :readonly="true"
        cur
      />
      <div class="input-group-append">
        <button
          class="btn btn-primary"
          type="button"
          @click="copyPermalink('GoogleMaps')"
          title="Kopiuj"
        >
          Kopiuj
        </button>
      </div>
      <div class="ml-1 input-group-append">
        <b-link
          class="btn btn-primary"
          type="button"
          @click="openLink(permalinks.googleMaps)"
          :href="'#'"
          target="_blank"
          title="Otwórz"
        >
          Otwórz
        </b-link>
      </div>
    </div>
    <b-row
      ><b-col class="d-flex justify-content-center"
        ><H5>Targeo</H5></b-col
      ></b-row
    >
    <div class="input-group mb-3 cursor-pointer">
      <input
        type="text"
        class="form-control"
        placeholder="Wygenerowany permalink"
        aria-label="Wygenerowany permalink"
        v-model="permalinks.targeo"
        :readonly="true"
      />
      <div class="input-group-append">
        <button
          class="btn btn-primary"
          type="button"
          @click="copyPermalink('Targeo')"
          title="Kopiuj"
        >
          Kopiuj
        </button>
      </div>
      <div class="ml-1 input-group-append">
        <b-link
          class="btn btn-primary"
          type="button"
          @click="openLink(permalinks.targeo)"
          :href="'#'"
          target="_blank"
          title="Otwórz"
        >
          Otwórz
        </b-link>
      </div>
    </div>
    <b-row
      ><b-col class="d-flex justify-content-center"
        ><H5>Geoportal</H5></b-col
      ></b-row
    >
    <div class="input-group mb-3 cursor-pointer">
      <input
        type="text"
        class="form-control"
        placeholder="Wygenerowany permalink"
        aria-label="Wygenerowany permalink"
        v-model="permalinks.geoportal"
        :readonly="true"
      />
      <div class="input-group-append">
        <button
          class="btn btn-primary"
          type="button"
          @click="copyPermalink('Geoportal')"
          title="Kopiuj"
        >
          Kopiuj
        </button>
      </div>
      <div class="ml-1 input-group-append">
        <b-link
          class="btn btn-primary"
          type="button"
          @click="openLink(permalinks.geoportal)"
          :href="'#'"
          target="_blank"
          title="Otwórz"
        >
          Otwórz
        </b-link>
      </div>
    </div>
    <b-row
      ><b-col class="d-flex justify-content-center"
        ><H5>Mapy Google street</H5></b-col
      ></b-row
    >
    <div class="input-group mb-3 cursor-pointer">
      <input
        type="text"
        class="form-control"
        placeholder="Wygenerowany permalink"
        aria-label="Wygenerowany permalink"
        v-model="permalinks.googleStreetMaps"
        :readonly="true"
      />
      <div class="input-group-append">
        <button
          class="btn btn-primary"
          type="button"
          @click="copyPermalink('GoogleStreetMaps')"
          title="Kopiuj"
        >
          Kopiuj
        </button>
      </div>
      <div class="ml-1 input-group-append">
        <b-link
          class="btn btn-primary"
          type="button"
          @click="openLink(permalinks.googleStreetMaps)"
          :href="'#'"
          target="_blank"
          title="Otwórz"
        >
          Otwórz
        </b-link>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <b-btn
        class="float-right ml-2"
        variant="outline-secondary"
        @click="cancel()"
        >Anuluj</b-btn
      >
    </div></b-modal
  >
</template>

<script>
import LoadingOverlay from 'vue-loading-overlay';
import { mapGetters } from 'vuex';
import { transform } from 'ol/proj';
import {
  WINDOW_MAP_PERMALINK_MODAL_HIDE,
  TOGGLE_CONTEXT_ASSISTANT
} from '../store/mutations.type';

import { DISPLAY_CONTEXT_ASSISTANT_MESSAGE } from '../store/actions.type';
export default {
  name: 'MapPermalinksModal',
  data() {
    return {
      linkCopiedModal: false,
      permalinks: {
        googleMaps: '',
        targeo: '',
        geoportal: '',
        googleStreetMaps: ''
      }
    };
  },
  props: {
    map: null
  },
  computed: {
    ...mapGetters([
      'mapPermalinksVisible',
      'isMobileDevice',
      'contextAssistantActive'
    ])
  },
  watch: {
    mapPermalinksVisible: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.generatePermalinks();
        }
      }
    }
  },
  methods: {
    cancel() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Naciśnięcie przycisku "Anuluj" zamyka narzędzie generowania permalinków.'
        });
      } else {
        this.setInitVariables();
        this.$store.commit(WINDOW_MAP_PERMALINK_MODAL_HIDE);
        // this.$emit('cancel');
      }
    },
    setInitVariables() {
      this.permalinks.googleMaps = '';
      this.permalinks.targeo = '';
      this.permalinks.geoportal = '';
      this.permalinks.googleStreetMaps = '';
    },
    generatePermalinks() {
      if (this.map) {
        this.generateGoogleMapsPermalink();
        this.generateTargeoPermalink();
        this.generateGeoportalPermalink();
        this.generateGoogleMapsStreetViewPermalink();
      }
    },
    generateGoogleMapsPermalink() {
      const url = `https://www.google.pl/maps/@{y},{x},{level}z`;
      const centerCoordinates = this.map.getView().getCenter();
      const transformedGeometryCenter = transform(
        centerCoordinates,
        'EPSG:2180',
        'EPSG:4326'
      );
      const centerX = transformedGeometryCenter[0];
      const centerY = transformedGeometryCenter[1];
      const zoom = this.map.getView().getZoom();
      const adjustVariable = 4.5;
      const minParameter = 0.5;
      const maxZoom = 28;
      const adjustedParameter =
        minParameter +
        (1.2 - minParameter) * (1 - Math.min(zoom, maxZoom) / maxZoom);

      const googleMapsZoom =
        Math.round((zoom * adjustedParameter) / 0.25) * 0.25 + adjustVariable;
      const permalinkUrl = url
        .replace('{y}', centerY)
        .replace('{x}', centerX)
        .replace('{level}', googleMapsZoom);

      this.permalinks.googleMaps = permalinkUrl;
    },
    generateTargeoPermalink() {
      const url = `https://mapa.targeo.pl/{x},{y},{level}`;
      const centerCoordinates = this.map.getView().getCenter();
      const transformedGeometryCenter = transform(
        centerCoordinates,
        'EPSG:2180',
        'EPSG:4326'
      );
      const centerX = transformedGeometryCenter[0];
      const centerY = transformedGeometryCenter[1];
      const zoom = this.map.getView().getZoom();
      const olMinZoom = 0;
      const olMaxZoom = 16;
      const targeoMinZoom = 30;
      const targeoMaxZoom = 17;
      const zoomFactor =
        (targeoMaxZoom - targeoMinZoom) / (olMaxZoom - olMinZoom);
      function openLayersToTargeoZoom(olZoom) {
        return targeoMinZoom + (olZoom - olMinZoom) * zoomFactor;
      }
      const mapZoom = openLayersToTargeoZoom(zoom);

      const permalinkUrl = url
        .replace('{y}', centerY)
        .replace('{x}', centerX)
        .replace('{level}', mapZoom);

      this.permalinks.targeo = permalinkUrl;
    },
    generateGeoportalPermalink() {
      let url =
        'https://mapy.geoportal.gov.pl/imap/Imgp_2.html?gpmap=gp0&bbox={minX},{minY},{maxX},{maxY}';
      const extent = this.map.getView().calculateExtent(this.map.getSize());
      const bottomLeft = [extent[0], extent[1]];
      const bottomRight = [extent[2], extent[1]];
      const topLeft = [extent[0], extent[3]];
      const topRight = [extent[2], extent[3]];
      const minX = Math.min(
        bottomLeft[0],
        bottomRight[0],
        topLeft[0],
        topRight[0]
      );
      const minY = Math.min(
        bottomLeft[1],
        bottomRight[1],
        topLeft[1],
        topRight[1]
      );
      const maxX = Math.max(
        bottomLeft[0],
        bottomRight[0],
        topLeft[0],
        topRight[0]
      );
      const maxY = Math.max(
        bottomLeft[1],
        bottomRight[1],
        topLeft[1],
        topRight[1]
      );
      const permalinkUrl = url
        .replace('{minX}', minX)
        .replace('{minY}', minY)
        .replace('{maxX}', maxX)
        .replace('{maxY}', maxY);

      this.permalinks.geoportal = permalinkUrl;
    },
    generateGoogleMapsStreetViewPermalink() {
      const url = `https://www.google.pl/maps?q=&layer=c&cbll={y},{x}`;
      const centerCoordinates = this.map.getView().getCenter();
      const transformedGeometryCenter = transform(
        centerCoordinates,
        'EPSG:2180',
        'EPSG:4326'
      );
      const centerX = transformedGeometryCenter[0];
      const centerY = transformedGeometryCenter[1];
      const permalinkUrl = url.replace('{y}', centerY).replace('{x}', centerX);

      this.permalinks.googleStreetMaps = permalinkUrl;
    },
    copyPermalink(targetMap) {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message: 'Naciśnięcie przycisku "Kopiuj" kopiuje wybrany permalink.'
        });
      } else {
        switch (targetMap) {
          case 'GoogleMaps':
            navigator.clipboard.writeText(this.permalinks.googleMaps);
            break;
          case 'Targeo':
            navigator.clipboard.writeText(this.permalinks.targeo);
            break;
          case 'Geoportal':
            navigator.clipboard.writeText(this.permalinks.geoportal);
            break;
          case 'GoogleStreetMaps':
            navigator.clipboard.writeText(this.permalinks.googleStreetMaps);
            break;
          // navigator.clipboard.writeText(copyText.value);
        }
        this.linkCopiedModal = true;
        setTimeout(() => {
          this.linkCopiedModal = false;
        }, 5000);
      }
    },
    openLink(link) {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Naciśnięcie przycisku "Otwórz" otwiera wybrany permalink w nowej karcie.'
        });
      } else {
        window.open(link, '_blank');
      }
    },
    toggleAssistant() {
      this.$store.commit(TOGGLE_CONTEXT_ASSISTANT);
    }
  }
};
</script>

<style>
.cursor-pointer {
  cursor: pointer !important;
}
</style>
